<input
    #file
    type="file"
    class="hidden"
    [accept]="accept()"
    (change)="onFilePicked($event.target)"
/>
<span [pTooltip]="disabledReason() ?? ''" tooltipPosition="left">
    <p-button
        label="Upload"
        icon="pi pi-upload"
        severity="secondary"
        [text]="true"
        size="small"
        [disabled]="disabled()"
        [loading]="busy()"
        (click)="file.click()"
    />
</span>
